import { render, staticRenderFns } from "./appointmentApply.vue?vue&type=template&id=380c2b48&scoped=true&"
import script from "./appointmentApply.vue?vue&type=script&lang=js&"
export * from "./appointmentApply.vue?vue&type=script&lang=js&"
import style0 from "./appointmentApply.vue?vue&type=style&index=0&id=380c2b48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c2b48",
  null
  
)

export default component.exports